import React from "react";
import { Grid, Skeleton, Stack } from "@mui/material";

export interface TPPanelSkeletonProps {
  show: boolean;
}

const TPPanelSkeleton: React.FC<TPPanelSkeletonProps> = ({ show }) => {
  if (!show) return null;

  return (
    <>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rounded" height={56} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rounded" height={56} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rounded" height={56} />
      </Grid>

      <Grid item xs={12} mt={3}>
        <Stack spacing={1.2}>
          <Skeleton variant="rounded" height={22} />
          <Skeleton variant="rounded" height={22} />
          <Skeleton variant="rounded" height={22} />
          <Skeleton variant="rounded" height={22} width="85%" />
        </Stack>
      </Grid>
    </>
  );
};

export default TPPanelSkeleton;
